import React from 'react'
import { Modal, Alert } from 'antd'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import { Link } from 'react-router-dom'
import SpeakerIcon from 'components/icons/SpeakerIcon'
import SpeakerIconExp from 'components/icons/SpeakerIconExp'
import CrossIconSkill from 'components/icons/CrossIconSkill'
import Checkbox from 'components/CheckboxSkill/Checkbox'
import { 
  FlexWrapRole 
} from './style'
import { 
  ContentStyleNew, 
  HorizontalDividerTitle, 
  UpdateContent,
  ExtraPadding,
  ButtonLocal
} from './roleStyle'
import { StyledDiv } from '../../Dashboard/Style/style'
import { AdjustIcon } from 'modules/Resume/DrawerComponents/DrawerStyle'
import AddIcon from 'components/icons/AddIcon'
import { Text } from 'modules/Onboarding/Register/WorkExperience/style'

const ExperienceModal = ({ 
  visible, 
  onClose, 
  roleFloatList,
  educationCheck,
  handleEducationCheck,
  selectedEdu,
  educationList,
  onCheckboxEdu,
  workCheck,
  handleWorkCheck,
  selectedWork,
  workList,
  onCheckboxWork,
  internCheck,
  handleInternshipCheck,
  selectedIntern,
  internList,
  onCheckboxIntern,
  trainingCheck,
  handleTrainingCheck,
  selectedTraining,
  trainingList,
  onCheckboxTraining,
  projectCheck,
  handleProjectCheck,
  selectedProject,
  projectList,
  onCheckboxProject,
  onSubmit,
  formId,
  studentExperience,
  experienceFromDate,
  addSkillDisable,
  click,
  clickIntern,
  clickProject,
  clickTraining,
  clickEducation,
  addingSkill
}) => {
  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      centered
      width="80%"
      footer={null}
      maskClosable={false}
      closable={true}
      destroyOnClose={true}
      bodyStyle={{
        padding: 0,
        borderRadius: '10px',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        {/* Content with scroll */}
        <div style={{ flex: 1, overflow: 'auto', padding: '30px' }}>
          {/* Title */}
          <div
            style={{
              fontWeight: 600,
              fontSize: '18px',
              lineHeight: '25px',
              color: '#343E59',
              marginBottom: '20px'
            }}
          >
            {`Where did you learn the skill "${addingSkill || '100 Plus Hatch Pattern Library'}" ?`}
          </div>

          {/* First info banner */}
          <div style={{
            backgroundColor: '#F0F4FF',
            borderRadius: '8px',
            padding: '15px',
            marginBottom: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start'
          }}>
            <div style={{ paddingTop: '10px', color: '#000000', display: 'flex', alignItems: 'center' }}>
              <SpeakerIconExp />
            </div>
            <span style={{ color: '#000000', fontSize: '14px', display: 'flex', alignItems: 'center' }}>Let us know where you learn this skill</span>
          </div>

          {/* Checkboxes section */}
          {roleFloatList?.academics?.length > 0 && (
            <Checkbox
              value={educationCheck}
              label={'Academics'}
              onChange={handleEducationCheck}
              list={selectedEdu}
              options={educationList}
              onChangeCheck={onCheckboxEdu}
              valueParam={'id'}
              labelParam={'educationLevel'}
            />
          )}
          {roleFloatList?.internships?.length > 0 && (
            <Checkbox
              value={internCheck}
              label={'Internship'}
              onChange={handleInternshipCheck}
              list={selectedIntern}
              options={internList}
              onChangeCheck={onCheckboxIntern}
              valueParam="id"
              labelParam="organization"
            />
          )}
          {roleFloatList?.workExperience?.length > 0 && (
            <Checkbox
              value={workCheck}
              label={'Work Experience'}
              onChange={handleWorkCheck}
              list={selectedWork}
              options={workList}
              onChangeCheck={onCheckboxWork}
              valueParam="id"
              labelParam="organization"
            />
          )}
          {roleFloatList?.courses?.length > 0 && (
            <Checkbox
              value={trainingCheck}
              label={'Training course'}
              onChange={handleTrainingCheck}
              list={selectedTraining}
              options={trainingList}
              onChangeCheck={onCheckboxTraining}
              valueParam="id"
              labelParam="title"
            />
          )}
          {roleFloatList?.projects?.length > 0 && (
            <Checkbox
              value={projectCheck}
              label={'Project'}
              onChange={handleProjectCheck}
              list={selectedProject}
              options={projectList}
              onChangeCheck={onCheckboxProject}
              valueParam="id"
              labelParam="title"
            />
          )}

          {/* Second info message */}
          <div style={{
            marginTop: '25px',
            marginBottom: '20px',
            display: 'flex',
            alignItems: 'center',

          }}>
            <div style={{ marginRight: '12px', color: '#9CA3AF', display: 'flex', alignItems: 'center' }}>
              <SpeakerIcon />
            </div>
            <span style={{ color: '#4D566E', fontSize: '14px', display: 'flex', alignItems: 'center' }}>
              {`Multiple ways you learned ${addingSkill || '100 Plus Hatch Pattern Library'}? Add them all here.`}
            </span>
          </div>
        
          {/* Buttons */}
          <div style={{ 
            display: 'flex', 
            flexWrap: 'wrap',
            gap: '15px',
            marginBottom: '30px',
            width: '100%'
          }}>
            <ButtonLocal onClick={clickEducation} style={{ flex: '1 0 auto', minWidth: '180px' }}>
              <Control alignCenter gap="10px" onClick={clickEducation}>
                <AdjustIcon>
                  <AddIcon />
                </AdjustIcon>
                <Text>Add Academics</Text>
              </Control>
            </ButtonLocal>
            <ButtonLocal onClick={clickProject} style={{ flex: '1 0 auto', minWidth: '180px' }}>
              <Control alignCenter gap="10px" onClick={clickProject}>
                <AdjustIcon>
                  <AddIcon />
                </AdjustIcon>
                <Text>Add Project</Text>
              </Control>
            </ButtonLocal>
           
            <ButtonLocal onClick={clickIntern} style={{ flex: '1 0 auto', minWidth: '180px' }}>
              <Control alignCenter gap="10px" onClick={clickIntern}>
                <AdjustIcon>
                  <AddIcon />
                </AdjustIcon>
                <Text>Add Internship</Text>
              </Control>
            </ButtonLocal>
        
            <ButtonLocal onClick={clickTraining} style={{ flex: '1 0 auto', minWidth: '180px' }}>
              <Control alignCenter gap="10px" onClick={clickTraining}>
                <AdjustIcon>
                  <AddIcon />
                </AdjustIcon>
                <Text>Add Certification</Text>
              </Control>
            </ButtonLocal>
            <ButtonLocal onClick={click} style={{ flex: '1 0 auto', minWidth: '180px' }}>
              <Control alignCenter gap="10px" onClick={click}>
                <AdjustIcon>
                  <AddIcon />
                </AdjustIcon>
                <Text>Add Work Experience</Text>
              </Control>
            </ButtonLocal>
          </div>
        </div>
        
        {/* Footer buttons - fixed at bottom */}
        <div style={{ 
          padding: '15px 30px', 
          borderTop: '1px solid #E6E7EA',
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '15px',
          backgroundColor: '#fff'
        }}>
          <Button.Secondary text="Close" onClick={onClose} />
          <Button.Primary
            form={formId}
            text={'Add'}
            onClick={onSubmit}
            disabled={
              !(
                (educationCheck && selectedEdu?.length > 0) ||
                (internCheck && selectedIntern?.length > 0) ||
                (trainingCheck && selectedTraining?.length > 0) ||
                (projectCheck && selectedProject?.length > 0) ||
                (workCheck && selectedWork?.length > 0)
              )
            }
          />
        </div>
      </div>
    </Modal>
  )
}

export default ExperienceModal
